export const themeColors = [
  "statusBarColor",
  "primaryBackgroundColor",
  "secondaryBackgroundColor",
  "labelTextColor",
  "editableTextColor",
  "primaryButtonBackgroundColor",
  "primaryButtonTextColor",
  "secondaryButtonBackgroundColor",
  "secondaryButtonTextColor",
  "listItemBackgroundColor",
  "listItemTextColor",
  "primaryIconColor",
  "secondaryIconColor",
  "primaryTextColor",
  "secondaryTextColor",
  "positiveButtonBackgroundColor",
  "positiveButtonTextColor",
  "negativeButtonBackgroundColor",
  "negativeButtonTextColor",
  "neutralButtonBackgroundColor",
  "neutralButtonTextColor",
  "navigationButtonTextColor",
  "navigationButtonIconColor"
]

export const defaultColors = [
  {
    "name": "primaryBackgroundColor",
    "value": "#17213b"
  },
  {
    "name": "secondaryBackgroundColor",
    "value": "#FFFFFF"
  },
  {
    "name": "primaryButtonBackgroundColor",
    "value": "#50e5e5"
  },
  {
    "name": "primaryButtonTextColor",
    "value": "#FFFFFF"
  },
  {
    "name": "secondaryButtonBackgroundColor",
    "value": "#FFFFFF"
  },
  {
    "name": "secondaryButtonTextColor",
    "value": "#1B1B1B"
  },
  {
    "name": "listItemBackgroundColor",
    "value": "#DDDDDD"
  },
  {
    "name": "listItemTextColor",
    "value": "#17213b"
  },
  {
    "name": "primaryIconColor",
    "value": "#17213b"
  },
  {
    "name": "secondaryIconColor",
    "value": "#50e5e5"
  },
  {
    "name": "primaryTextColor",
    "value": "#50e5e5"
  },
  {
    "name": "secondaryTextColor",
    "value": "#FFFFFF"
  }
]